// @ts-nocheck
import ApiService from './ApiService';
import LoginApi from './login/LoginApi';
import UserApi from './user/UserApi';
import ReservationApi from './reservation/ReservationApi';
import V3LoginApi from './login/V3LoginApi';
import V3ReservationApi from './reservation/V3ReservationApi';
import V3UserApi from './user/V3UserApi';
import VehicleApi from "./vehicle/VehicleApi";
import V3VehicleApi from './vehicle/V3VehicleApi';
import WalleyApi from './walley/WalleyApi';
import V3WalleyApi from './walley/V3WalleyApi';
import SecureLS from 'secure-ls';

const aesC = new SecureLS({ encodingType: 'aes', encryptionSecret: import.meta.env.VITE_TSEC });
class V3ApiService implements ApiService {
  dbToken: string;
  jwt: string;
  apiUrl: string;
  walleyApiUrl: string;
  login: LoginApi;
  reservation: ReservationApi;
  user: UserApi;
  vehicle: VehicleApi;
  walley: WalleyApi;
  changeRoute: (() => void) | undefined;

  constructor(dbToken: string, jwt: string, apiUrl: string, changeRoute: (() => void) | undefined, walleyApiUrl: string = '') {
    this.dbToken = dbToken;
    this.jwt = jwt;
    this.apiUrl = apiUrl;
    this.walleyApiUrl = walleyApiUrl;
    this.changeRoute = changeRoute;
    this.login = new V3LoginApi(this.fetchCustom);
    this.reservation = new V3ReservationApi(this.fetchCustom);
    this.user = new V3UserApi(this.fetchCustom);
    //this.misc = new V3MiscApi(this.fetchCustom);
    this.vehicle = new V3VehicleApi(this.fetchCustom);
    this.walley = new V3WalleyApi(walleyApiUrl, () => this.jwt);
  }

  setDbToken = (token: string, jwt: string) => {
    this.dbToken = token;
    this.jwt = jwt;
  };

  fetchCustom = (
    url: string,
    options?: any,
    addAuthHeader: boolean = true
  ): Promise<any> => {
    // let fullUrl = this.apiUrl + "/index.php" + url;
    const fullUrl = this.apiUrl + url;

    if (addAuthHeader) {
      options = {
        ...options,
        headers: {
          Authorization: "Bearer " + this.dbToken,
          jwt: this.jwt
        }
      };
    }

    if (options?.method === "POST" || options?.method === "PATCH")
    {
      options.headers = {
        ...options.headers,
        Accept: "application/json",
        "Content-Type": "application/json"
      };
      if (!options.body) {
        options.body = JSON.stringify({});
      }
    }

    return fetch(fullUrl, options)
      .then(res => {
        const fetchError = this.statusCheck(res, false, options?.body ? JSON.stringify(options.body).slice(0, 1024) : undefined);
        if (fetchError) {
          return fetchError;
        }

        const contentType = res.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return res.json().then(result => {
            return result.data;
          });
        } else {
          return res;
        }
      })
      .catch(err => {
        return new Promise((resolve, rej) => rej('Network: ' + err));
      });
  };

  statusCheck = (res: any, isJson: boolean, bodyStart?: string) => {
    if (res.status === 401) {
      aesC.remove('C2-XT');
      aesC.remove('C2-STORE');
      this.setDbToken('', '');
      if (this.changeRoute) {
        this.changeRoute();
      }
      return new Promise((resolve, reject) => reject('NOTOKEN'));
    }
    if (res.status !== 200 && res.status !== 201 && res.status !== 204) {
      return res.json().then(result => {
        return new Promise((resolve, reject) =>{
          if(result.data) {
            reject(
              result.data._errorMessage === ""
                ? result.data._error + (result.data.body ? JSON.stringify(result.data.body) : '') + (bodyStart ? bodyStart : '')
                : result.data._error + " - " + result.data._errorMessage + (result.data.body ? JSON.stringify(result.data.body) : '') + (bodyStart ? bodyStart : '')
            )
          }
          else
            reject("INTERNAL SERVER ERROR")
        }
        );
      });
    }
    return undefined;
  };
}

export default V3ApiService;
